<!--
 * @Description: 资产总值(万元)
 * @Autor: xiaona.wang
 * @Date: 2021-12-14 20:56:34
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-07-18 16:37:26
-->
<template>
  <div id="assets_total" class="box_conetnt"/>
</template>

<script>
import * as echarts from "echarts";
import cockpitApi from "@/api/cockpit/cockpit";
import resize from "./mixins/resize";

export default {
  name: "AssetsTotal",
  mixins: [resize],
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getAssetsTotal();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeSetData() {
      setTimeout(() => {
        this.chart && this.chart.resize();
      }, 200);
    },
    // 获取资产总值接口数据
    getAssetsTotal(type) {
      const param = {};
      if (type) {
        param.searchType = type;
      }
      cockpitApi.getAssetsTotal(param).then(result => {
        if (result.code === 200 && result.success) {
          const echartsData = [];
          let total = 0;
          result.data.map(item => {
            const temp = {};
            temp.name = item.deptName;
            temp.value = (Number(item.value) / 10000).toFixed(2);
            total += temp.value;
            echartsData.push(temp);
          });
          this.drawAssetsTotal(total, echartsData);
        }
      });
    },
    // echarts
    drawAssetsTotal(total = "0", echartsData = []) {
      this.chart = echarts.init(document.getElementById("assets_total"));
      this.chart.setOption({
        title: {
          text: "资产总值(万元)",
          align: "right"
        },
        color: ["#668AFF", "#0DDFB7", "#FBC12E", "#3BAAFF", "#7F59F0", "#D4D9E2"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          icon: "circle",
          bottom: "0",
          itemHeight: 8,
          itemWidth: 8
        },
        series: [
          {
            name: "资产总值(万元)",
            type: "pie",
            center: ["45%", "45%"], // 图的位置，距离左跟上的位置
            avoidLabelOverlap: false,
            top: "40px",
            bottom: "30px",
            label: {
              normal: {
                show: true, // 展示
                position: "outside", // outside表示文本显示位置为外部
                formatter: "{b}\n({d}%)"
              },
              emphasis: {
                // 文本样式
                show: true, // 展示
                textStyle: {
                  // 文本样式
                  fontSize: "14",
                  fontWeight: "600"
                }
              }
            },
            labelLine: {
              show: true
            },
            data: echartsData
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box_conetnt{
  width:100%;
  height:100%;
  padding:24px 24px 16px;
}
</style>
